import React from 'react';

import createHeartComponent from '@finn-no/favorite-heart-component';
import {
  BapSearchAd,
  AdImage
} from '@schibsted-nmp/search-frontend-components/react';

import type { MartailerProduct } from '../utils/MartailerApi.js';

export type SimpleBapSearchAdProps = {
  layout?: 'grid' | 'list';
  onClick?: () => void;
  products: Array<MartailerProduct>;
};

export type LabelRenderProps = {
  className?: string;
  classes: {
    badge: string;
    info: string;
    warning: string;
    success: string;
    [key: string]: string;
  };
};

export function SponsoredListingAd({
  layout = 'grid',
  onClick,
  products
}: SimpleBapSearchAdProps) {
  const product = products[0];
  if (!product) return null;
  const bapAd = convertToBapFormat(product);

  const IMAGE_SIZES =
    '(min-width: 1300px) 306px, (min-width: 1010px) 316px, (min-width: 768px) 33vw, (min-width: 480px) 50vw, 100vw';

  const Heart = createHeartComponent({
    userId: '12345',
    baseUri: '',
    redirectUrl: ''
  });

  return (
    <BapSearchAd
      ad={bapAd}
      currentTime={Date.now()}
      favorite={() => (
        <Heart
          variant={layout === 'grid' ? 'heart-on-image' : 'heart'}
          itemId={parseInt(bapAd.ad_id.split('-').pop() || '0', 10)}
          itemType="Ad"
          buttonClass=""
          locale="sv"
          isMobile={false}
        />
      )}
      id={bapAd.ad_id}
      imageSizes={IMAGE_SIZES}
      label={(props: LabelRenderProps) => (
        <span
          className={`${props.className} ${props.classes.badge} ${props.classes.info}`}
        >
          Paid Position
        </span>
      )}
      layout={layout}
      onClick={onClick}
      url={bapAd.canonical_url}
      image={
        layout === 'grid'
          ? () => (
              <AdImage
                aspectClass="aspect-3/4"
                height={bapAd.image.height}
                width={bapAd.image.width}
                url={bapAd.image.url}
                crop={true}
                sizes={IMAGE_SIZES}
              />
            )
          : undefined
      }
    />
  );
}

function convertToBapFormat(product: MartailerProduct) {
  return {
    ad_id: product.adId,
    canonical_url: product.link,
    distance: null,
    extras: [],
    flags: [],
    heading: product.title,
    image: {
      aspect_ratio: 1.3333333333333333,
      height: 400,
      url: product.imageLink,
      width: 533
    },
    labels: [
      {
        id: 'paid_position',
        label: 'Paid Position',
        type: 'PRIMARY' as const
      }
    ],
    location: '',
    main_search_key: 'SEARCH_ID_BAP_COMMON',
    organisation_name: product.organisationName,
    price: {
      currency_code: 'EUR',
      amount: product.price,
      price_unit: '€'
    },
    timestamp: 1234567890,
    trade_type: 1
  };
}
